import React, { useState } from 'react';

// material-ui
import { Grid, Button, Menu, MenuItem, TextField, InputAdornment } from '@mui/material';
import { Add, Search } from '@mui/icons-material';

// assets
import useLeagues from 'hooks/useLeagues';

const AddPlayerPoolChip = () => {
    const { selectedEvent, submitNewPoolToEventInstance } = useLeagues();
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [newGroupName, setNewGroupName] = useState('');

    const handleMenuClick = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleClose = () => setMenuAnchorEl(null);

    const handleSubmitPool = () => {
        handleClose();
        setNewGroupName('');
        submitNewPoolToEventInstance({ event_instance_id: selectedEvent?.id, name: newGroupName });
    };

    const handleGroupNameChange = (value) => {
        setNewGroupName(value);
    };

    return (
        <Grid item container xs={12}>
            <Button
                startIcon={<Add />}
                variant="outlined"
                sx={{ borderRadius: 10, paddingY: 1 }}
                color="secondary"
                onClick={handleMenuClick}
            >
                Add A Group
            </Button>
            <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                keepMounted
                onClose={handleClose}
                variant="selectedMenu"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                <MenuItem>
                    <TextField
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Search fontSize="small" />
                                </InputAdornment>
                            )
                        }}
                        onChange={(e) => handleGroupNameChange(e.target.value)}
                        placeholder="Player Group Name"
                        value={newGroupName}
                        size="small"
                    />
                    <Button
                        startIcon={<Add />}
                        variant="outlined"
                        sx={{ borderRadius: 10, paddingY: 1, ml: 1 }}
                        color="secondary"
                        onClick={handleSubmitPool}
                    >
                        Add
                    </Button>
                </MenuItem>
            </Menu>
        </Grid>
    );
};

export default AddPlayerPoolChip;
